import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';
import { BroadcastDetailsResponse } from '@/client/types/whatsapp/broadcast-campaigns';

type QueryResponse = BroadcastDetailsResponse;

export const createBroadcastDetailsQueryKey = (id: string) => [
  'whatsapp-broadcast-details',
  id,
];

export const useGetBroadcastDetailsQuery = (id: string, additionalProps = {}) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while fetching WhatsApp Config',
    endpoint: `/api/admin/whatsapp/broadcast/${id}`,
  });

  return useQuery({
    queryKey: createBroadcastDetailsQueryKey(id),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};